import React from "react";
import { useNavigate, useParams, useSearchParams } from "react-router";
import { useClaService } from "../../../adapters/cla/state/hooks/useClaService.ts";
import { ChatBox } from "../../../feature-components/ChatBox/ChatBox.tsx";
import { useIsChatBoxSending } from "../../../adapters/cla/state/hooks/stateHooks.ts";
import { useFeatureFlagValue } from "../../../config/FeatureFlagManager/hooks";
import { getEnvironment } from "../../../config/getEnvironment.ts";

export const ConnectedChatBox: React.FC = () => {
  const claService = useClaService();
  const { id } = useParams();
  const navigate = useNavigate();
  const isSending = useIsChatBoxSending();
  const [searchParams] = useSearchParams();
  const enableDeepResearchAgent = useFeatureFlagValue(
    "enableDeepResearchAgent",
  );
  const enableCloudRun = useFeatureFlagValue("enableCloudRun");
  const enableProductTestingBusinessDomain = useFeatureFlagValue(
    "enableProductTestingBusinessDomain",
  );
  return (
    <ChatBox
      processing={isSending}
      onSubmit={async (value) => {
        if (!id) return;
        console.log("submitting message to chat:", id, value);
        if (id === "new") {
          // DEV ONLY: Allow overriding agent name via URL query parameter
          const agentNameOverride =
            getEnvironment() === "dev" ? searchParams.get("agent") : null;

          const newChatId = await claService.createChatSession({
            initial_message: value,
            agent: enableDeepResearchAgent ? "DRA" : "DSA",
            engine: enableCloudRun ? "cloudrun" : "agentengine",
            businessDomain: enableProductTestingBusinessDomain
              ? "InnovationProductTesting"
              : "InnovationConceptTesting",
            agentNameOverride: agentNameOverride || undefined,
          });
          if (!newChatId) throw new Error("Failed to create chat session.");
          await claService.sendMessage({
            message: value,
            chatId: newChatId,
            skipEventLogging: true,
          });
          navigate(`/chats/${newChatId}`);
        } else {
          await claService.sendMessage({ message: value, chatId: id });
        }
      }}
    />
  );
};
